import { render, staticRenderFns } from "./tradeLeadNew.vue?vue&type=template&id=1a459bd5&scoped=true&"
import script from "./tradeLeadNew.vue?vue&type=script&lang=js&"
export * from "./tradeLeadNew.vue?vue&type=script&lang=js&"
import style0 from "./tradeLeadNew.vue?vue&type=style&index=0&id=1a459bd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a459bd5",
  null
  
)

export default component.exports